import React from 'react';
import { faFileContract } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const ReportIcon = ({ toolTipText = 'Report' }) => (
  <Icon tooltip={toolTipText} iconObj={faFileContract} />
);

export default ReportIcon;